import { renderTaggedPrintNotes } from '@mummssoftware/common-ui';
import defaults from '../../../translations/en.json';

export const PrintNote = ({ notes }) =>
  renderTaggedPrintNotes(notes, defaults.relatedNote);
